import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a3d8db5181ede8840c3518245dfe31073b from "./generated-ae03aec8-b7b0-408b-a089-418da6bb91f4.json";

import af4896da25a1b43996178ce409cdd8f7cb from "./generated-3d86c116-5a99-47eb-bfa5-f3cf32d8aeb8.json";

import a57c7ca09120591155fc83a32e939750ab from "./generated-646baea6-a185-4dbb-94bb-1987251eaea0.json";

import a1d6b04bbe680ce2c5ae0ce1855f0ba6db from "./generated-dff43fe6-65bc-4bd0-bd6d-e86686f15bdf.json";

import a9ff6efb83e20f44f55f451a4abc2ace1b from "./generated-f2781cea-618b-489c-a02d-e83eb1282163.json";

import a137e2319df5090c5c2babe8d550d50deb from "./generated-06dbfa1b-6fb5-4b87-85f6-6711051122c5.json";

import a6c2e0c26a58fea9ea1f2eda90c9684d2b from "./generated-fe33da71-d3c9-420f-b035-18e0917adffb.json";

import aaf49b21daa1b2ac0dfd134b449fa6c4bb from "./generated-7116200f-1863-4f09-bc3e-b3fa822837cd.json";

import a237a0e99f41d2d3f0e76cd5a25a565dab from "./generated-7868f835-ea54-4c3c-bbe6-bbac8a01d95e.json";

import a1e796e76606f795cac45f269b4efc1b2b from "./generated-3c966a8c-873a-448b-9aad-42d6ec93d060.json";

import a967947a09399b2df82c6938f386f3747b from "./generated-fdf0447d-3606-4118-ad4c-7c72e5764ccc.json";

import af532c27434d6a95e6e8622fd8e23695ab from "./generated-2a39b801-8b18-4b00-abe7-fbe2391122ff.json";

import ab8c397a338445fdbd7dc18e523a1c7b0b from "./generated-3c287ed2-9196-494b-bb37-2a8b88756905.json";

import a53d1df62703c4cc05b61664ff3a5c029b from "./generated-2e59e8e1-b2c2-4328-8018-cf59d4691820.json";

import a5b3aa52fa3b825c76ba73d8d58a8e28db from "./generated-e15d35ec-ce9f-422a-bbfa-a8485339c717.json";

import af4599b2fe096e2f991230bebbf1851ffb from "./generated-8a72ba34-526c-40b1-bdc8-2f3ddce4ae83.json";

import a9cb2be175a5a8e5b381227e226460465b from "./generated-2a59c958-c6d4-46ed-81ef-06212c7ad264.json";

import a368d2f165b28150cbb242c5832971bccb from "./generated-0cee3620-3a72-49f0-8f8b-fa9c94e2d6d8.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a3d8db5181ede8840c3518245dfe31073b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(af4896da25a1b43996178ce409cdd8f7cb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a57c7ca09120591155fc83a32e939750ab);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a1d6b04bbe680ce2c5ae0ce1855f0ba6db);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a9ff6efb83e20f44f55f451a4abc2ace1b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a137e2319df5090c5c2babe8d550d50deb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a6c2e0c26a58fea9ea1f2eda90c9684d2b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(aaf49b21daa1b2ac0dfd134b449fa6c4bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a237a0e99f41d2d3f0e76cd5a25a565dab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a1e796e76606f795cac45f269b4efc1b2b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a6c2e0c26a58fea9ea1f2eda90c9684d2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a967947a09399b2df82c6938f386f3747b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(af532c27434d6a95e6e8622fd8e23695ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(ab8c397a338445fdbd7dc18e523a1c7b0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a53d1df62703c4cc05b61664ff3a5c029b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a5b3aa52fa3b825c76ba73d8d58a8e28db);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(af4599b2fe096e2f991230bebbf1851ffb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a9cb2be175a5a8e5b381227e226460465b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a368d2f165b28150cbb242c5832971bccb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(af4599b2fe096e2f991230bebbf1851ffb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */